/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFormat,
    JsonFormatFromJSON,
    JsonFormatFromJSONTyped,
    JsonFormatToJSON,
} from './JsonFormat';

/**
 * 
 * @export
 * @interface ApiResultOfJsonFormat
 */
export interface ApiResultOfJsonFormat {
    /**
     * 
     * @type {JsonFormat}
     * @memberof ApiResultOfJsonFormat
     */
    data?: JsonFormat;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFormat
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonFormat
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFormat
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFormat
     */
    result?: ApiResultOfJsonFormatResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonFormatResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonFormatFromJSON(json: any): ApiResultOfJsonFormat {
    return ApiResultOfJsonFormatFromJSONTyped(json, false);
}

export function ApiResultOfJsonFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonFormat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonFormatFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonFormatToJSON(value?: ApiResultOfJsonFormat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonFormatToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

